module.exports = __webpack_public_path__ + "static/media/agent.5016b718.svg";